class BubbleAdjuster {
  constructor() {
    this.adjustBubbleToLabel = this.adjustBubbleToLabel.bind(this);
    this.texts = document.querySelectorAll('.form__range-text-item')
    this.texts_in = document.querySelector('.form__range-text-in')
  }

  adjustBubbleToLabel(label) {
    const bubble = document.getElementById('bubble');
    const rangeSelector = document.querySelector('.form__range');
    const labelRect = label.getBoundingClientRect();
    const containerRect = rangeSelector.getBoundingClientRect();
    const activeText = this.texts[this.getIndex(label.parentElement)]
    bubble.style.width = `${labelRect.width}px`;
    bubble.style.height = `${labelRect.height}px`;
    bubble.style.left = `${labelRect.left - containerRect.left}px`;
    bubble.style.top = `${label.offsetTop}px`;

    this.hideTexts()

    activeText.removeAttribute('hidden')

    this.texts_in.style.height = activeText.getBoundingClientRect().height+'px'
  }

  hideTexts(){
    this.texts.forEach(el => {
      el.setAttribute('hidden', 'hidden')
    })
  }

  getIndex(el){
    return [...el.parentElement.children].indexOf(el);
  }

  initializeEventListeners() {
    const labels = document.querySelectorAll('.form__range-label');
    labels.forEach(label => {
      label.addEventListener('click', () => this.adjustBubbleToLabel(label));
    });
  }
}

const bubbleAdjuster = new BubbleAdjuster();
bubbleAdjuster.initializeEventListeners();
